import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { CommonService } from 'src/app/_services/common.service';
import { AlertService } from 'src/app/_helpers/alert.service';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit {

  hidePassword: boolean = true;
  showLoader: boolean = false;

  @ViewChild('loginNgForm') loginNgForm!: NgForm;
  loginForm: FormGroup = this._formBuilder.group({
    email : ['', [
      Validators.required,
      Validators.email,
      Validators.pattern(this._commonService.emailRegex)
    ]],
    password : ['', [
      Validators.required
    ]],
    rememberMe : [false],
  });

  constructor(
    private _title: Title,
    private _formBuilder: FormBuilder,
    private _authService: AuthService,
    private _alertService: AlertService,
    private _commonService: CommonService
  ) {
    this._title.setTitle('Admin: Login');
  }

  ngOnInit(): void {
  }

  login() {
    // Return if the form is invalid
    if (this.loginForm?.invalid) {
      return;
    }

    this.showLoader = true;
    this._authService.signIn(this.loginForm.value).subscribe({
      next: (response: any) => {
        const { isSuccess, message } = response;
        if(isSuccess) {
          this._commonService.userDefaultRoute();
        } else {
          this._alertService.show_alert(message, '', 'error');
        }
        this.showLoader = false;
      },
      error: (errorResponse) => {
        this.showLoader = false;
        this._alertService.show_alert(errorResponse?.message, '', 'error');
      }
    });
  }

}
